import React from 'react';
import { useQuery } from '@apollo/react-hooks';
import { Platform, View, StyleSheet, ScrollView } from 'react-native';
import { Q_GET_MY_PROFILE } from '../../data/api/query/q_users';
import { handleExpiredJWT } from '../../utils/handleExpiredJWT';
import { resetAuthToken, user_id, resetUserObject } from '../../data/api/client/authToken';
import { AuthContext } from '../../App';
import { PageLoadingIndicator, LoadingIndicator } from '../../components/LoadingIndicator';
import { PlanTypeOptions } from '../home.screen';
import { useScreenDimensions, getItemWidth } from '../../utils/useScreenInfo';
import { GraphQLError } from 'graphql';
import { Layout, Text, Button, Modal, Avatar, BasicCard, useTheme } from '../../components/_primatives';



export function ProfileScreen({ navigation, route }): React.ReactElement {
    const { isMediumScreenOrLarger, isLargeScreenOrLarger, pageSpacerHorizontal, bodyWidth } = useScreenDimensions();
    const theme = useTheme();
    const MAIN_COLOR: string = theme['color-primary-default'];
    const params = route?.params;
    console.log({ navigation, route, params });
    const [isLoading, setIsLoading] = React.useState(false);
    const authContext = React.useContext(AuthContext);
    console.log('authContext', { authContext });
    const { signOut, user } = authContext;

    const profileRequest = useQuery(Q_GET_MY_PROFILE, {
        variables: { user_id: user.id },
        fetchPolicy: 'network-only'
    });
    const { loading, error, data, refetch } = profileRequest;


    if (loading) {
        return <PageLoadingIndicator />
    };
    if (error) {
        console.log('useQuery', { profileRequest });
        const graphQLErrors: GraphQLError[] = handleExpiredJWT(error, () => {
            alert('Your login has expired. Please login');
            navigation.navigate('LoginOrSignup', { actionType: 'login' });
        });
        // graphQLErrors.forEach(err => err.extensions.code === 'validation-failed' ? alert('validation-failed') : undefined);
        console.log({ graphQLErrors });
        <View>
            <Button appearance='ghost' style={{ width: 193 }} onPress={() => refetch()}>Refresh</Button>
            <Button appearance='ghost' style={{ width: 193 }} onPress={() => navigation.navigate('LoginOrSignup', { actionType: 'login' })}>Home</Button>

        </View>
        
    };
    console.log('we have data, ', data)

    const profileData: any = data.v_user_profile[0];
    console.log('we have profileData, ', profileData);

    const renderHeader = () => (
        <View style={{ marginVertical: 20, marginBottom: 30, paddingHorizontal: isMediumScreenOrLarger ? 0 : 23 }}>
            <View style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'baseline', flexWrap: 'wrap' }}>
                <View>
                    <Text category='h1'>{'Account'}</Text>
                    <View style={{ width: 90, backgroundColor: MAIN_COLOR, height: 4 }}></View>
                </View>
                    {/* {profileData.avatar ?
                        <Avatar source={{ uri: profileData.avatar }} size={'giant'} style={{  alignSelf: 'flex-end'}} />
                        : undefined
                    } */}
            </View>
        </View>
    );
    const renderFooter = () => (
        <View style={{ marginVertical: 20, marginBottom: 30, paddingHorizontal: isMediumScreenOrLarger ? 0 : 23 }}>
            <Button appearance='filled' style={{ width: 193 }} onPress={async () => {
                setIsLoading(true);
                await resetUserObject();
                await resetAuthToken();
                signOut();
            }}>
                Logout
            </Button>
        </View>
    );

    return (
        <Layout level={'1'} style={{ flex: 1 }}>
            <ScrollView
                style={{ flex: 1, paddingHorizontal: pageSpacerHorizontal }}
                contentContainerStyle={isMediumScreenOrLarger ? { width: bodyWidth, alignSelf: 'center', paddingTop: 0 } : { paddingHorizontal: pageSpacerHorizontal }}
            >
                {renderHeader()}
                <BasicCard style={isMediumScreenOrLarger ? { marginBottom: 15 } : { borderWidth: 0 }}>
                    <View style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
                        <Text category='s1'>{`Username:`}</Text>
                        <Text>{`${profileData.username}`}</Text>
                    </View>
                    <View style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
                        <Text category='s1'>{`Email:`}</Text>
                        <Text>{`${profileData.email}`}</Text>
                    </View>
                    <View style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
                        <Text category='s1'>{`Avatar:`}</Text>
                        <Text>{`${profileData.avatar ? profileData.avatar : 'none'}`}</Text>
                    </View>
                </BasicCard>
                <BasicCard style={isMediumScreenOrLarger ? { marginBottom: 15 } : { borderWidth: 0 }}>
                    <View style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
                        <Text category='s1'>{`Plan`}</Text>
                        <Text>{`${profileData.product_plan_title}${__DEV__ ? ' (' + profileData.product_plan_id + ')' : ''}`}</Text>
                    </View>
                    <View style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
                        <Text category='s1'>{`Organization:`}</Text>
                        <Text>{`${profileData.org_title}`}</Text>
                    </View>
                    {/* <View style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
                            <Text category='s1'>{`User Id:`}</Text>
                            <Text>{`${profileData.id}`}</Text>
                        </View> */}
                    {profileData.system_user ? (
                        <View style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
                            <Text category='s1'>{`System User:`}</Text>
                            <Text>{`${profileData.system_user}`}</Text>
                        </View>
                    ) : undefined}
                    <View style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
                        <Text category='s1'>{`Registered:`}</Text>
                        <Text>{`${(new Date(profileData.created_at).toLocaleDateString())}`}</Text>
                    </View>
                    <View style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
                        <Text category='s1'>{`Invited Date:`}</Text>
                        <Text>{`${(new Date(profileData.invited_date).toLocaleDateString())}`}</Text>
                    </View>
                    <View style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
                        <Text category='s1'>{`Inviter_user_id:`}</Text>
                        <Text>{`${profileData.inviter_user_id}`}</Text>
                    </View>
                </BasicCard>
                {renderFooter()}
                <Modal backdropStyle={{ backgroundColor: 'rgba(0, 0, 0, 0.5)' }} onBackdropPress={() => undefined} visible={isLoading}>
                    <BasicCard>
                        <LoadingIndicator />
                    </BasicCard>
                </Modal>
            </ScrollView>
        </Layout>
    );
}





const styles = StyleSheet.create({
    input: {
        margin: 10,
    },
    footerContainer: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        marginVertical: 20
    },
    footerControl: {
        // marginTop: 5,
        // marginBottom: 5,
        // paddingLeft: 10
    },
});